export default "__VITE_ASSET__BOST4omf__"